import React from 'react'
import { getListItems, changeListItem, nullDate } from 'tyan/public/utility'
import { hasChangedValues, getFormValue, changeItemsValue } from 'tyan/public/utility/formValues'

class SalaryInfoAdjustDiv extends React.Component {
	state = {
		changedValues基本信息: {},
		saveing: false
	}
	componentDidMount = () => {
		this.doGetSalaryInfo()
	}

	doGetSalaryInfo = () => {
		const { id, personId } = this.props
		Tyan.doPostEvent({
			event: 'GetSingleSalaryInfo',
			data: {
				id: id,
				personId: personId
			},
			onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				} else {
					this.setState({ id, initValues基本信息, changedValues基本信息: {}, optionsParas })
				}
			}
		})
	}

	fieldset基本信息 = () => {
		const { personId } = this.props
		const { initValues基本信息, optionsParas } = this.state
		const { 状态, 提交时间 } = initValues基本信息
		const { 员工姓名 } = initValues基本信息
		const 显示列 = optionsParas['显示列']
		const p = { margin: '5px 5px 5px 5px', minWidth: 1, _full: true, flex: 1, clearable: false }
		const list = { listName: '薪资明细', id: personId }
		return [
			{
				_border: `${员工姓名}`, name: `薪资明细_${personId}`, list, minWidth: '95%', margin: '15px 5px 5px 5px', items: [
					{
						_group: '', minWidth: '95%', items: [
							{ _label: '科目名称', ...p },
							{ _label: '金额', ...p },
							{ _label: '申请备注', ...p },
							{ _label: '审批结果', cdt: () => 状态 == 2, ...p },
							{ _label: '审批备注', cdt: () => (状态 == 1 && 提交时间 !== nullDate) || 状态 == 2, ...p }
						]
					}].concat(显示列 && 显示列.map(n => {
						const value = getFormValue(this, '基本信息', `薪资明细[${personId}].金额_${n.name}`)
						const 原值 = getFormValue(this, '基本信息', `薪资明细[${personId}].原值_${n.name}`)
						const 是否修改 = getFormValue(this, '基本信息', `薪资明细[${personId}].是否修改_${n.name}`)
						const bDisabled = getFormValue(this, '基本信息', `薪资明细[${personId}].bDisabled_${n.name}`)
						let ui = ''
						if ((状态 == 1 && value !== 原值) || (状态 == 2 && 是否修改 == '是') || (状态 == 3 && value !== 原值))
							ui = 'red'
						return {
							_group: '', minWidth: '95%', items: [
								{ _label: n.showName, name: n.name, ...p },
								{
									_float: '', name: `金额_${n.name}`, ...p,
									disabled: bDisabled,
									decimals: n.name == '工伤保险公司扣款比例' ? 3 : 2,
									ui: ui,
								},
								{ _text: '', name: `备注_${n.name}`, /* disabled: true */ disabled: bDisabled, ...p },
								{ _select: '', name: `审批结果_${n.name}`, ...p, options: ['', '驳回'], disabled: 状态 !== 2 || !n.edit, cdt: () => 状态 == 2 },
								{ _text: '', name: `审批备注_${n.name}`, ...p,/* disabled: true */disabled: 状态 !== 2 || !n.edit, cdt: () => (状态 == 1 && 提交时间 !== nullDate) || 状态 == 2 }
							]
						}
					}))
			}
		]
	}

	handlerClose = () => {
		const { onClose } = this.props
		if (!this.bChanged()) {
			onClose && onClose()
			return
		}
		Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
	}

	handlerSave = () => {
		const { id, personId, onSave, onClose } = this.props
		const { changedValues基本信息, saveing } = this.state
		if (!saveing) {
			const { list: list薪资明细 } = Tyan.utility.getListItems(this, '基本信息', '薪资明细')
			this.setState({ saveing: true })
			Tyan.doPostEvent({
				event: 'SaveSingleSalaryInfo',
				data: {
					id,
					personId,
					list薪资明细,
					changedValues基本信息,
				},
				onEnd: ({ errorMessage }) => {
					this.setState({ saveing: false })
					if (errorMessage) {
						Tyan.pubForm.showError(errorMessage)
					} else {
						Ext.toast('保存成功')
						onClose && onClose()
						onSave && onSave()
					}
				}
			})
		}
	}

	bSave = () => {
		const { changedValues基本信息 } = this.state
		return Object.keys(changedValues基本信息).length > 0
	}

	bChanged = () => {
		return hasChangedValues(this)
	}
	render() {
		const { showMessage: Message, showBody: Body } = this.props
		const { initValues基本信息 } = this.state
		if (!initValues基本信息) return <Message text={'请稍等 ...'} />
		const { 状态名称 } = initValues基本信息
		return <Body data={this} maxWidth="900"
			controls={
				[{ _button: '保存', icon: 'save', handler: () => this.handlerSave(''), disabled: !this.bSave(), cdt: () => 状态名称 == '调薪申请' || 状态名称 == '调薪审核' },
				{ _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
				]}
			fieldsets={
				[{ title: '', name: '基本信息', _fieldset: this.fieldset基本信息() }]}
		/>
	}
}
export default SalaryInfoAdjustDiv